import { useEffect, useRef } from 'react';
import { Button } from '@/ui/components/Button';
import { useTerms } from '../../hooks/useTerms';
import { useNavigate } from 'react-router-dom';
import styles from './AnafTermsPage.module.scss';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { Icon } from '@/ui/icons/Icon';

function AnafTermsPage() {
  const navigate = useNavigate();
  const { getPartnerAnafTerms, partnerAnafTerms, isLoading, setAcceptedTerms } =
    useTerms();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    getPartnerAnafTerms();
  }, [getPartnerAnafTerms]);

  useEffect(() => {
    if (!iframeRef.current || !partnerAnafTerms) return;
    const doc = iframeRef.current.contentDocument;
    if (!doc) return;

    doc.body.innerHTML = partnerAnafTerms.content;
    // There is a margin 8px already present so add 8px to the padding
    doc.body.style.setProperty('padding', '8px', 'important');
  }, [partnerAnafTerms]);

  const handleContinue = () => {
    setAcceptedTerms({
      anaf: true,
    });
    navigate(-1);
  };

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.termsContainer}>
          <h1 className={styles.title}>
            Acordul explicit pentru interogarea la ANAF
          </h1>

          <iframe
            ref={iframeRef}
            className={styles.termsText}
            title="ANAF Terms"
            sandbox="allow-same-origin"
          />
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          trackingId="accept_anaf_terms"
          variant="filled"
          text="Continuă"
          className={styles.button}
          onClick={handleContinue}
          rightIcon={<Icon name="arrow-right" />}
        />
      </div>
    </div>
  );
}

export default AnafTermsPage;
